document.addEventListener("DOMContentLoaded", () => {
  // 节流函数
  function throttle(func, delay) {
    let timer = null;
    return function () {
      const context = this;
      const args = arguments;
      if (!timer) {
        timer = setTimeout(function () {
          func.apply(context, args);
          timer = null;
        }, delay);
      }
    };
  }

  const computedPaddingLeft = () => {
    // 计算nav导航的左边距
    const leftPadding = document
      .querySelector("nav.header__inline-menu")
      .getBoundingClientRect().left;
    // 计算logo距离左边的距离
    let logoElement = document.querySelector("h1.header__heading");
    if (!logoElement) {
      logoElement = document.querySelector(".header__heading-link");
    }
    const { left: logoLeftPadding } = logoElement.getBoundingClientRect();
    document
      .querySelectorAll(".header__inline-menu .menu-drawer__card-menu")
      .forEach(
        (item) =>
          (item.style.paddingLeft = `${leftPadding - logoLeftPadding}px`)
      );
  };
  computedPaddingLeft();
  window.addEventListener("resize", throttle(computedPaddingLeft, 500));

  // 给移动端的二级导航点击添加事件
  document.querySelectorAll(".menu-drawer__menu-item").forEach((item) => {
    item.addEventListener("click", () => {
      item.classList.toggle("open");
    });
  });

  // 产品详情页设置header吸顶
  const headerEl =
    document.querySelector(
      ".header_no_sticky .section-header.shopify-section-group-header-group"
    ) ||
    document.querySelector(
      ".section-header.shopify-section-group-header-group"
    );
  const productInfo = document.querySelector("product-info");
  if (productInfo) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // product-info 进入视口：header 吸顶
            headerEl.classList.add("sticky");
          } else {
            // product-info 离开视口：header 恢复默认
            headerEl.classList.remove("sticky");
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(productInfo);
  }

  // 监听页面滚动事件，给透明导航栏加白色底
  const checkPageY = () => {
    if (window.pageYOffset > 80) {
      headerEl.classList.add("white-bg");
    } else {
      headerEl.classList.remove("white-bg");
    }
  };
  window.addEventListener("scroll", checkPageY);
  checkPageY();
});
